import { evolve, omit } from 'ramda'

export const makeInitialValues = evolve({
  address: omit(['addressId']),
})
